import { render, staticRenderFns } from "./SentenceStyle.vue?vue&type=template&id=39eb7215&scoped=true&"
import script from "./SentenceStyle.vue?vue&type=script&lang=js&"
export * from "./SentenceStyle.vue?vue&type=script&lang=js&"
import style0 from "./SentenceStyle.vue?vue&type=style&index=0&id=39eb7215&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eb7215",
  null
  
)

export default component.exports